import { useEffect, useState } from 'react';
import { getInstance as getBootstrap } from 'utils/bootstrap';
import { useLocalStorage } from '@rehooks/local-storage';
import differenceInMinutes from 'date-fns/differenceInMinutes';
import {
    PAGE_STATE_PRE_EVENT,
    PAGE_STATE_CHECK_IN,
    PAGE_STATE_DURING_EVENT,
    PAGE_STATE_DURING_EVENT_MULTI_SESSION,
    EVENT_CUTOFF_TIME_MINUTES,
    TYPE_VIRTUAL_EVENT_MULTISESSION,
} from 'common/constants/virtualEvent';

const bootstrap = getBootstrap();
const eventId = parseInt(bootstrap.get('event.id', null), 10);

export function useVEPStateMachine({ enabled, event }) {
    const [currentPageState, setCurrentPageState] = useState(null);
    const [vepTokens] = useLocalStorage(`splashVirtualEvent/${eventId}`);

    useEffect(() => {
        if (enabled) {
            const { eventStart } = event;

            const startDate = eventStart && new Date(+eventStart * 1000);
            const now = new Date();
            const minutesRemaining = differenceInMinutes(startDate, now);

            const isTBD = window.isNaN(minutesRemaining);
            const checkinIsAvailable = isTBD || minutesRemaining <= EVENT_CUTOFF_TIME_MINUTES;
            const isSessionVirtualEvent = event?.multisession === TYPE_VIRTUAL_EVENT_MULTISESSION;
            const userHaventCheckedIn = !vepTokens?.checkInToken;

            if (checkinIsAvailable && userHaventCheckedIn) {
                setCurrentPageState(PAGE_STATE_CHECK_IN);
            } else if (!checkinIsAvailable) {
                setCurrentPageState(PAGE_STATE_PRE_EVENT);
            }

            if (!userHaventCheckedIn) {
                setCurrentPageState(
                    isSessionVirtualEvent ? PAGE_STATE_DURING_EVENT_MULTI_SESSION : PAGE_STATE_DURING_EVENT,
                );
            }
        }
    }, [vepTokens, enabled, event]);

    return { currentPageState, setCurrentPageState };
}
